import { render, staticRenderFns } from "./AddChapterPopup.vue?vue&type=template&id=a8b952b2"
import script from "./AddChapterPopup.vue?vue&type=script&lang=js"
export * from "./AddChapterPopup.vue?vue&type=script&lang=js"
import style0 from "./AddChapterPopup.vue?vue&type=style&index=0&id=a8b952b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports